import React from "react";
import { formatToDate } from "../../master/FormatToDateTime";

const MarkReports = ({ data }) => {
  const getAllTests = (data) => {
    const testMap = {};

    data?.course_and_fees?.forEach((course) => {
      course.tests?.forEach((test) => {
        if (!testMap[test.id]) {
          testMap[test.id] = test;
        }
      });
    });

    return Object.values(testMap);
  };

  const tests = getAllTests(data);

  const totalTests = tests.length;

  const avgPercentage =
    tests.length > 0
      ? (
          tests.reduce((sum, test) => {
            const total =
              test.subjects_mark?.reduce(
                (s, x) => s + Number(x.total_marks || 0),
                0,
              ) || 0;

            const obtained =
              test.subjects_mark?.reduce(
                (s, x) =>
                  s +
                  Number(x.obtained_marks === "A" ? 0 : x.obtained_marks || 0),
                0,
              ) || 0;

            return sum + (total ? (obtained / total) * 100 : 0);
          }, 0) / tests.length
        ).toFixed(1)
      : 0;

  return (
    <div className="row">
      <div className="col-12">
        <div className="card">
          <div className="card-body px-2">
            <div className="card-header bg-transparent border-0 py-3">
              <div className="d-flex justify-content-between align-items-center">
                <div>
                  <h5 className="mb-0 fw-bold">Test Performance Report</h5>

                  <small className="text-muted">
                    Subject-wise marks and overall performance
                  </small>
                </div>

                <span className="badge bg-label-primary">
                  {tests.length} Tests
                </span>
              </div>
            </div>
            <div className="row g-3 mb-3">
              <div className="col-md-4">
                <div className="card border-0 shadow-sm">
                  <div className="card-body text-center">
                    <h3 className="mb-0">{totalTests}</h3>
                    <small className="text-muted">Total Tests</small>
                  </div>
                </div>
              </div>

              <div className="col-md-4">
                <div className="card border-0 shadow-sm">
                  <div className="card-body text-center">
                    <h3 className="mb-0 text-primary">{avgPercentage}%</h3>
                    <small className="text-muted">Average Score</small>
                  </div>
                </div>
              </div>

              <div className="col-md-4">
                <div className="card border-0 shadow-sm">
                  <div className="card-body text-center">
                    <h3 className="mb-0 text-success">
                      {
                        tests.filter((test) => {
                          const total =
                            test.subjects_mark?.reduce(
                              (s, x) => s + Number(x.total_marks || 0),
                              0,
                            ) || 0;

                          const obtained =
                            test.subjects_mark?.reduce(
                              (s, x) =>
                                s +
                                Number(
                                  x.obtained_marks === "A"
                                    ? 0
                                    : x.obtained_marks || 0,
                                ),
                              0,
                            ) || 0;

                          return total && (obtained / total) * 100 >= 60;
                        }).length
                      }
                    </h3>

                    <small className="text-muted">Passed Tests</small>
                  </div>
                </div>
              </div>
            </div>
            <div className="table-responsive">
              <table className="table table-hover">
                <thead className="table-light">
                  <tr>
                    <th>#</th>
                    <th>Test</th>
                    <th>Date</th>
                    <th>Subjects</th>
                    <th>Total</th>
                    <th>Obtained</th>
                    <th>%</th>
                    <th>Grade</th>
                  </tr>
                </thead>

                <tbody>
                  {tests?.map((test, index) => {
                    const total = test.subjects_mark?.reduce(
                      (sum, s) => sum + Number(s.total_marks || 0),
                      0,
                    );

                    const obtained = test.subjects_mark?.reduce(
                      (sum, s) =>
                        sum +
                        Number(
                          s.obtained_marks === "A" ? 0 : s.obtained_marks || 0,
                        ),
                      0,
                    );

                    const percentage = total
                      ? ((obtained / total) * 100).toFixed(2)
                      : 0;

                    const grade =
                      percentage >= 90
                        ? "A+"
                        : percentage >= 80
                          ? "A"
                          : percentage >= 70
                            ? "B"
                            : percentage >= 60
                              ? "C"
                              : percentage >= 40
                                ? "D"
                                : "F";

                    return (
                      <tr key={test.id}>
                        <td>{index + 1}</td>
                        <td>{test.title}</td>
                        <td>{formatToDate(test.date)}</td>

                        <td>
                          <div className="d-flex flex-wrap gap-1">
                            {test.subjects_mark?.map((sub, i) => (
                              <span
                                key={i}
                                className="badge rounded-pill bg-label-primary"
                              >
                                {sub.subject_name}
                              </span>
                            ))}
                          </div>
                        </td>

                        <td>{total}</td>
                        <td>{obtained}</td>

                        <td style={{ minWidth: 180 }}>
                          <div className="d-flex justify-content-between mb-1">
                            <small>{percentage}%</small>
                          </div>

                          <div
                            className="progress"
                            style={{
                              height: 8,
                              borderRadius: 10,
                            }}
                          >
                            <div
                              className={`progress-bar ${
                                percentage >= 60
                                  ? "bg-success"
                                  : percentage >= 40
                                    ? "bg-warning"
                                    : "bg-danger"
                              }`}
                              style={{
                                width: `${percentage}%`,
                              }}
                            />
                          </div>
                        </td>
                        <td>
                          <span
                            className={`badge rounded-pill ${
                              grade === "A+"
                                ? "bg-success"
                                : grade === "A"
                                  ? "bg-primary"
                                  : grade === "B"
                                    ? "bg-info"
                                    : grade === "C"
                                      ? "bg-warning"
                                      : "bg-danger"
                            }`}
                          >
                            {grade}
                          </span>
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MarkReports;
